import { action, makeObservable, observable } from 'mobx';
import { Option } from 'src/integration/types/Option';
import dayjs from 'dayjs';

class SettingsStore {
  @observable siteList: Option[] = [];
  @observable selectedSiteId: Nullable<number> = null;
  @observable selectedDate: string = dayjs().format('YYYY-MM-DD');

  @action setSelectedDate(date: Date | string) {
    this.selectedDate = dayjs(date).format('YYYY-MM-DD');
  }

  @action setSiteId(id: Nullable<number>) {
    if (id == null) return this.setInitialSiteId;
    this.selectedSiteId = id;
  }

  @action setInitialSiteId(){
    this.selectedSiteId = this.siteList[0].id
  }

  @action setSiteList = (sites: SimpleObject) => {
    const siteList: SimpleObject[] = sites.data;

    this.siteList = siteList.map((data) => ({
      id: data.id,
      title: data.siteName,
    }));

    this.setInitialSiteId();
  }

  constructor() {
    makeObservable(this);
  }
}

export default SettingsStore;
